var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{style:(!_vm.isMobile && _vm.isMultiOrg ? 'padding-left: 334px' : null)},[(_vm.$route.name !== 'Live Events')?_c('div',{staticStyle:{"height":"76px"}}):_vm._e(),_c('toaster-container'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }